export type Stages = 'draft' | 'qc_check' | 'review' | 'outcome';

export type EntityType = 'site' | 'study';

export type EntityTypeExtend = EntityType | 'workspace';

export const STAGES_AFTER_QC = new Set<Stages>(['review', 'outcome']);

export const SUBMISSSION_DETAILS_V2_PATH = 'v2/submissions';
